import React from 'react';

export const MaskTop = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="196" height="196" viewBox="0 0 196 196" fill="none">
    <mask id="mask0_6721_144" maskUnits="userSpaceOnUse" x="0" y="0" width="196" height="196">
      <rect width="196" height="196" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_6721_144)">
      <path
        d="M61.936 0.20018C61.936 36.249 91.1594 65.4724 127.208 65.4724C91.1594 65.4724 61.936 94.6957 61.936 130.745C61.936 166.793 91.1594 196.017 127.208 196.017H198.936C234.985 196.017 264.208 166.793 264.208 130.745C264.208 94.6957 234.985 65.4724 198.936 65.4724C234.985 65.4724 264.208 36.249 264.208 0.200172C264.208 -35.8487 234.985 -65.072 198.936 -65.072L127.208 -65.072C91.1594 -65.072 61.936 -35.8486 61.936 0.20018Z"
        fill="#3DA490"
      />
    </g>
  </svg>
);
